<template>
    <div class="container">
        <template v-if="group.length > 0 && groupActiveIndex != null">
            <div class="title">
                <span>{{years[yearsCheckedIndex].name}}</span>
                <span v-if="isHighSchool && group[groupActiveIndex].className">&nbsp;&gt;&nbsp;{{group[groupActiveIndex].className}}</span>
                <span>&nbsp;&gt;&nbsp;{{group[groupActiveIndex].name}}</span>
                <span v-if="group[groupActiveIndex].type == 0 && panorama.length > 1">&nbsp;&gt;&nbsp;{{panorama[panoramaActiveIndex].name}}</span>
            </div>
            <!-- 全景图 -->
            <template v-if="group[groupActiveIndex].type == 0">
                <PhotoSphereViewer ref="PhotoSphereViewer" :src="panorama[panoramaActiveIndex].image" :x="panorama[panoramaActiveIndex].x" :y="panorama[panoramaActiveIndex].y" :markers="panorama[panoramaActiveIndex].markers" :width="panorama[panoramaActiveIndex].width" :height="panorama[panoramaActiveIndex].height" @tapArrow="photoSphereTapArrow" @loaded="photoSphereLoaded"/>
            </template>
            <template v-else-if="group[groupActiveIndex].video_type == 0">
                <PhotoSphereViewer ref="PhotoSphereViewer" :src="panorama[panoramaActiveIndex].image" :x="panorama[panoramaActiveIndex].x" :y="panorama[panoramaActiveIndex].y" :markers="panorama[panoramaActiveIndex].markers" :width="panorama[panoramaActiveIndex].width" :height="panorama[panoramaActiveIndex].height" @tapArrow="photoSphereTapArrow" @loaded="photoSphereLoaded"/>
            </template>
            <!-- 普通视频 -->
            <template v-else-if="group[groupActiveIndex].video_type == 1">
                <div class="normal_video">
                    <div class="bg" :style="`background-image: url(${group[groupActiveIndex].background_img})`"></div>
                    <video class="video" @play="normalVideoPlay" @pause="normalVideoPause" :src="group[groupActiveIndex].file" x5-playsinline="" playsinline="" webkit-playsinline="" controls></video>
                </div>
            </template>
            <!-- 全景视频 -->
            <template v-else-if="group[groupActiveIndex].video_type == 2">
                <VideoSphereViewer ref="VideoSphereViewer" :src="group[groupActiveIndex].file" :poster="group[groupActiveIndex].image" :pan="group[groupActiveIndex].init_pan" :tilt="group[groupActiveIndex].init_tilt" :fov="group[groupActiveIndex].init_fov" @play="isShowEndBtn = true"/>
            </template>
            <!-- 轮播图 -->
            <template v-else-if="group[groupActiveIndex].video_type == 4">
                <FullSwiper :data="group[groupActiveIndex].banner"/>
            </template>
            <!-- 按钮 上一个 -->
            <div class="btn_prev" :class="{active: groupActiveIndex > 0}" @click="tourPrev"><span>{{$t('prev')}}</span></div>
            <!-- 按钮 下一个 -->
            <div class="btn_next" :class="{active: groupActiveIndex < group.length - 1}" @click="tourNext"><span>{{$t('next')}}</span></div>
            <!-- end 弹窗按钮 -->
            <div class="end_btn" :class="{active: isShowEndBtn, type2: isShowTour}" v-if="group[groupActiveIndex].type == 2" @click="showSelect">{{$t('contactPuDong')}}</div>
            <!-- end 弹窗 -->
            <SelectPopup :show="isShowSelect" @close="$store.state.isShowSelect = false"/>
            <!-- 右下角视频音频 -->
            <VideoPopup ref="videoPopup" :video="group[groupActiveIndex].video" :text="group[groupActiveIndex].video_desc" :audio="group[groupActiveIndex].audio" :videoWidth="group[groupActiveIndex].video_width" :videoHeight="group[groupActiveIndex].video_height"/>
            <!-- 图组轮播图列表 -->
            <div class="tour_group" :class="{active: isShowTour}">
                <div class="top" @click="isShowTour = !isShowTour">{{$t('myTour')}}</div>
                <TourSwiper :activeIndex="groupActiveIndex" @slideTap="tourTap"/>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import FullSwiper from '../components/fullSwiper.vue';
import PhotoSphereViewer from '../components/photoSphereViewer.vue';
import SelectPopup from '../components/selectPopup.vue';
import TourSwiper from '../components/tourSwiper.vue';
import VideoPopup from '../components/videoPopup.vue';
import VideoSphereViewer from '../components/videoSphereViewer.vue';
export default {
    name: "tour",
    data() {
        return {
            groupActiveIndex: null, //图组索引
            panoramaActiveIndex: null, //全景图索引
            isHighSchool: process.env.VUE_APP_IS_HIGH_SCHOOL == '1', //是否是高中
            isShowTour: false, //是否显示图组轮播图
            isShowEndBtn: false, //是否显示结束视频按钮
            isChangeGroup: false, //是否更新过组索引
            isPreview: false, //预览
            // 
            oldPathName: '',
        };
    },
    computed: {
        ...mapState(['years', 'yearsActiveIndex', 'yearsCheckedIndex', 'group', 'isShowSelect']),
        panorama() { 
            return this.group[this.groupActiveIndex].panorama
        }
    },
    components: {
        VideoSphereViewer,
        PhotoSphereViewer,
        TourSwiper,
        SelectPopup,
        VideoPopup,
        FullSwiper
    },
    mounted() {

    },
    destroyed() {},
    watch: {
        groupActiveIndex(index) { 
            this.setLink();
            this.isChangeGroup = true;

            if(index == this.group.length - 1 && this.group[index].video_type != 2){
                this.isShowEndBtn = true;
            }
        },
        panoramaActiveIndex: 'setLink',
        '$route.params.name': {
            handler(){
                let name = this.$route.params.name.split('_').map((v) => { return v.replace(/-/g, ' ') });
                // console.log(name)
                // 如果store里面没有数据就从sessionStorage里找id数组重新请求
                // 这种可能是页面刷新触发的
                if (this.group.length == 0) { 
                    let payload = {};
                    if(this.$route.params.name == 'test'){
                        // this.$route.query.id
                        // 预览
                        this.isPreview = true;
                        payload.id = this.$route.query.id;
                        payload.type = this.$route.query.type;
                        payload.hot_id = this.$route.query.hot_id;
                    }else{
                        // 正式
                        let groupIdStorage = sessionStorage.getItem(`${process.env.VUE_APP_NAME}_group_id`);
                        if (groupIdStorage) { 
                            // 如果有id数组，就用id数组请求
                            payload.id = groupIdStorage;
                        } else {
                            // 如果sessionStorage里也没有就重新请求，这次用名称请求
                            // 这种可能是直接用链接到的图组
                            // 这种就没办法分选中不选中图组了，直接全部返回
                            payload = {
                                age: name[0],
                                name: name[1],
                                panorama_name: name[2] ? name[2] : '',
                            }
                        }
                    }
                    this.$showLoading();
                    this.$store.dispatch('getPanorama', payload).then(() => { 
                        this.$hideLoading();
                        // 再去循环数组，用链接名称去对比，获取当前的这个
                        this.getIndex(name);
                    })
                } else if(name[0] != this.oldPathName) {
                    this.groupActiveIndex = 0;
                    this.panoramaActiveIndex = 0;
                    // this.getIndex(name);
                }
                this.oldPathName = name[0];
            },
            immediate: true
        }
    },
    methods: {
        // 设置link
        setLink() { 
            if(this.isPreview){
                return false;
            }
            let yearsName = this.years[this.yearsActiveIndex].en_name.replace(/ /g, '-');
            let group = this.group[this.groupActiveIndex];
            let groupName = group.en_name.replace(/ /g, '-');
            let panoramaName = '';
            if (group.type == 0) { 
                // 是全景图组
                panoramaName = group.panorama[this.panoramaActiveIndex].en_name.replace(/ /g, '-');
            }
            let link = `${yearsName}_${groupName}`;
            if (panoramaName != '') { 
                link += `_${panoramaName}`;
            }
            if (this.$route.path != `/tour/${link}`) { 
                this.$router.push(`/tour/${link}`);
            }
        },
        // 获取索引
        getIndex(name) { 
            for (let i = 0, l = this.years.length; i < l; i++) { 
                if (this.years[i].en_name == name[0]) { 
                    this.$store.state.yearsActiveIndex = i;
                    this.$store.state.yearsCheckedIndex = i;
                    break;
                }
            }
            for (let i = 0, l = this.group.length; i < l; i++) { 
                let item = this.group[i];
                if (item.en_name == name[1]) { 
                    this.groupActiveIndex = i;
                    if (item.type == 0 && name[2]) { 
                        for (var j = 0, jl = item.panorama.length; j < jl; j++) { 
                            if (item.panorama[j].en_name == name[2]) { 
                                this.panoramaActiveIndex = j;
                                break;
                            }
                        }
                    }
                    break;
                }
            }
            if (this.groupActiveIndex == null) { 
                this.groupActiveIndex = 0;
            }
            if (this.panoramaActiveIndex == null) { 
                this.panoramaActiveIndex = 0;
            }
        },
        tourPrev() { 
            this.isLoading(() => {
                this.panoramaActiveIndex = 0;
                this.groupActiveIndex--;
            })
        },
        tourNext() { 
            this.isLoading(() => {
                this.panoramaActiveIndex = 0;
                this.groupActiveIndex++;
            })
        },
        tourTap(index) { 
            this.isLoading(() => {
                this.panoramaActiveIndex = 0;
                this.groupActiveIndex = index;
            })
        },
        isLoading(resolve) { 
            this.isShowEndBtn = false;
            if (this.group[this.groupActiveIndex].type == 0) { 
                // 全景图
                if (!this.$refs.PhotoSphereViewer.loading) { 
                    resolve();
                }
            } else if(this.group[this.groupActiveIndex].video_type == 2) {
                // 全景视频
                if (!this.$refs.VideoSphereViewer.loading) { 
                    resolve()
                }
            } else {
                // 普通视频
                resolve();
            }
        },
        photoSphereTapArrow({ id }) { 
            for (let i = 0, l = this.panorama.length; i < l; i++) { 
                if (this.panorama[i].id == id) { 
                    this.panoramaActiveIndex = i;
                    break;
                }
            }
        },
        photoSphereLoaded() { 
            if (this.isChangeGroup) { 
                this.$refs.videoPopup.playAudio();
                this.isChangeGroup = false;
            }
        },
        showSelect(){
            this.$store.state.isShowSelect = true;
            // trackEvent
            this.$trackEvent('connect');
        },
        normalVideoPlay(){
            this.$refs.videoPopup.$refs.bgAudio.pause();
        },
        normalVideoPause(){
            this.$refs.videoPopup.$refs.bgAudio.play();
        },
    },
};
</script>

<style scoped lang="scss">
.title{
    position: absolute;
    top: .25rem;
    left: .3rem;
    font-size: .16rem;
    font-weight: bold;
    color: #fff;
    z-index: 2;
    text-shadow: 0 0 .1rem rgba($color: #000000, $alpha: .4);
    @media only screen and (max-width: 640px) {
        font-size: .2rem;
    }
}
.btn_prev,
.btn_next{
    position: absolute;
    top: 50%;
    left: 1.2rem;
    display: flex;
    align-items: center;
    text-decoration: underline;
    font-size: .18rem;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    z-index: 98;
    animation: prev 1s both linear infinite alternate;
    opacity: 0;
    visibility: hidden;
    // text-shadow: 0 0 .1rem rgba($color: #000000, $alpha: .6);
    filter: drop-shadow(0 0 .1rem rgba($color: #000000, $alpha: .6));
    &.active{
        opacity: 1;
        visibility: visible;
    }
    @keyframes prev {
        0%{
            transform: translate(0, -50%);
        }
        100%{
            transform: translate(0.2rem, -50%);
        }
    }
    &::before{
        content: '';
        display: block;
        width: .2rem;
        height: .3rem;
        background: url('../assets/images/icon_group_prev.png') no-repeat 0/100%;
        margin-right: .1rem;
    }
    @media only screen and (max-width: 640px) {
        left: .3rem;
        span{
            display: none;
        }
        &::before{
            width: .34rem;
            height: .52rem;
        }
    }
}
.btn_next{
    left: auto;
    right: 1.2rem;
    flex-direction: row-reverse;
    animation: next 1s linear infinite alternate;
    @keyframes next {
        0%{
            transform: translate(0, -50%);
        }
        100%{
            transform: translate(-0.2rem, -50%);
        }
    }
    &::before{
        background-image: url('../assets/images/icon_group_next.png');
        margin-right: 0;
        margin-left: .1rem;
    }
    @media only screen and (max-width: 640px) {
        right: .3rem;
    }
}
.tour_group{
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    z-index: 100;
    width: 2rem;
    height: .3rem;
    border-radius: .04rem .04rem 0 0;
    overflow: hidden;
    transition: width .3s .3s, height .3s, background-color .3s .3s;
    &.active{
        width: 6.5rem;
        height: 1.8rem;
        background: rgba($color: #000000, $alpha: .6);
        transition: width .3s, height .3s .3s, background-color .3s;
        .top{
            &::after{
                background-image: url('../assets/images/icon_arrow_down.png');
            }
        }
    }
    .top{
        background: rgba($color: #000000, $alpha: .6);
        width: 100%;
        height: .3rem;
        font-size: .18rem;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &::after{
            content: "";
            display: block;
            width: .16rem;
            height: .08rem;
            background: url('../assets/images/icon_arrow_up.png') no-repeat 0/100%;
            margin-left: .06rem;
        }
    }
    @media only screen and (max-width: 640px) {
        bottom: 0;
        left: 0;
        transform: none;
        width: 100%;
        height: .6rem;
        border-radius: 0;
        transition: height .3s, background-color .3s;
        &.active{
            width: 100%;
            height: 2.8rem;
            transition: height .3s, background-color .3s;
        }
        .top{
            height: .6rem;
            font-size: .24rem;
            &::after{
                width: .2rem;
                height: .1rem;
            }
        }
    }
}
.end_btn{
    width: 6.4rem;
    height: .6rem;
    font-size: .16rem;
    font-weight: bold;
    position: absolute;
    bottom: .6rem;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2;
    background: #fff;
    border-radius: .04rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    visibility: hidden;
    transition: transform .3s;
    &::after{
        content: "";
        display: block;
        width: .11rem;
        height: .2rem;
        margin-left: .12rem;
        background: url('../assets/images/icon_home_btn_arrow_01.png') no-repeat 0/100%;
        animation: btnArrow 1s linear alternate infinite;
    }
    @keyframes btnArrow {
        0%{
            transform: translate(-50%, 0);
        }
        100%{
            transform: translate(50%, 0);
        }
    }
    @media only screen and (max-width: 640px) {
        width: 6.5rem;
        bottom: 2rem;
    }
    &.active{
        animation: showBtn .5s 0s both;
    }
    &.type2{
        transform: translate(-50%, -1.4rem);
        transition-delay: .3s;
    }
    @keyframes showBtn {
        0%{
            opacity: 0;
            visibility: hidden;
        }
        100%{
            opacity: 1;
            visibility: visible;
        }
    }
}
.normal_video{
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    .bg{
        position: absolute;
        top: -20px;
        left: -20px;
        right: -20px;
        bottom: -20px;
        background-repeat: no-repeat;
        background-size: cover;
        filter: blur(10px);
    }
    .video{
        position: absolute;
        width: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #000;
        @media only screen and (max-width: 640px) {
            width: 100%;
        }
    }
}
</style>